<template>
  <div class="knowledge-content-detail">
    <div class="page-body">
      <el-page-header content="版画知识详情" @back="goBack" />

      <div class="knowledge-box">
        <div class="title">
          {{ pageData.ArticleTitle }}
        </div>
        <div class="subtitle">
          <div>
            <span> 发布时间： </span>
            <span>
              {{
                moment(pageData.UpdateTime).format('YYYY年MM月DD日  hh:mm:ss')
              }}
            </span>
          </div>

          <div>
            <span>发布者：</span>
            <span>
              {{ pageData.AddUser }}
            </span>
          </div>
          <div>
            <span>分类：</span>
            <span>{{ knowledgeType[pageData.ArticleSort] }}</span>
          </div>
        </div>
        <div class="knowledge-text-body" v-html="pageData.ArticleContent"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment'
import replaceImgPath from '../../../utils/replace-img-path'
import { getKnowledgeDetail } from '../../../apis'

import { useRoute, useRouter } from 'vue-router'
import { ref } from 'vue'
const knowledgeType = {
  102: '版种介绍',
  103: '版画知识'
}
const route = useRoute()
const pageData = ref({})
const router = useRouter()
const goBack = () => {
  router.go(-1)
}
const getData = () => {
  getKnowledgeDetail(route.query.id).then((res) => {
    pageData.value = res.data.data
    // console.log(pageData.value.ArticleContent)

    pageData.value.ArticleContent = replaceImgPath(
      pageData.value.ArticleContent
    )
  })
}
getData()
</script>
<style lang="scss">
.knowledge-content-detail {
  .title {
    font-size: 26px;
    text-align: center;
    margin: 30px auto 10px;
  }
  .subtitle {
    display: flex;
    justify-content: center;
    margin: 20px auto;
    color: rgb(102, 102, 102);
    div {
      margin: 0 20px;
      // background: #fff;
      // padding: 4px;
      font-size: 14px;
    }
  }
  .knowledge-box {
    padding: 20px 5%;
    background: rgba($color: #fff, $alpha: 0.4);
  }
  .page-body {
  }
}
</style>
